import React, { useEffect, useState } from 'react'
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Grid, TextField, Divider,
    Box,
    Typography,
    Paper,
    Select, MenuItem, FormControl, InputLabel
} from '@mui/material'
import api from '../../services/api'
import InputMask from 'react-input-mask'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ptBR } from 'date-fns/locale'
import { isValid } from 'date-fns';

export default function PmesDialog({ open, onClose, editing }) {
    const [form, setForm] = useState({})

    const [comments, setComments] = useState([])
    const [newCommentText, setNewCommentText] = useState('')

    const [setores, setSetores] = useState([])
    const [usuarios, setUsuarios] = useState([])

    const unidadesSenai = ["123", "562", "701"]
    const portesEmpresa = ["Pequena Empresa", "Microempresa", "Média Empresa (demais)"]
    const tiposApoio = [
        "Não aplicável",
        "Apoio técnico remoto durante o diagnóstico (atendimento remoto)",
        "Engenharia de aplicação/tecnologias de alto impacto (atendimento presencial)"
    ]
    const sprints = [
        "1. Reunião de Abertura",
        "2. Desenvolvimento técnico",
        "3. Qualificação técnica",
        "4. Orçamentos e Fatores Financeiros do Projeto",
        "5. Finalização do relatório",
        "6. Plano de apoio à implementação e apresentação p/PME",
        "7. Diagnóstico finalizado",
        "X. Processo cancelado pela PME",
        "Projeto em revisão técnica"
    ]

    const elegibilidadeFaee = [
        "Elegível",
        "Não elegível",
        "Em análise de elegibilidade",
        "Em ajuste de orçamento",
        "Solicitar adequação técnica",
        "Em adequação técnica",
        "N/A"
    ]

    const statusReuniaoImpl = [
        "Diagnóstico não concluído",
        "Agendamento Pendente",
        "Reunião Agendada",
        "Reunião Realizada"
    ]

    const modalidadesImpl = [
        "Financiamento com DSP",
        "Financiamento com outros bancos",
        "Implementação total com recursos próprios",
        "Implementação com BOT ou Performance",
        "Implementação parcial com recursos próprios",
        "Não irá implementar",
        "Pendente Decisão (fazer novo contato futuro)",
        "N/A"
    ]

    const statusApoioDecisao = [
        "0. Pendente de tratativa com a PME",
        "1. Reunião agendada",
        "2. Reunião realizada",
        "3. Projeto em revisão técnica (consultores do programa)",
        "4. Atualização de orçamentos e documentação para financiamento (consultores do programa)",
        "5. Tratativa concluída",
        "Não cabe tratativa"
    ]

    const motivosNaoImpl = [
        "N/A",
        "Saúde financeira da empresa",
        "Pendência documental da empresa (licenciamento ambiental, CND, etc)",
        "Prioridade para outras demandas internas na empresa (ex.: outros investimentos)",
        "Baixa atratividade financeira do projeto (ex.: payback longo, TIR muito baixa, etc.)",
        "MEEs tecnicamente inviáveis ou não aplicáveis",
        "Burocracia na obtenção do financiamento",
        "Mudanças no processo produtivo (ex.: local da planta, descontinuidade de linha de produção, etc)",
        "Cliente não ficou satisfeito com a solução proposta"
    ]

    const enquadramentoFinep = [
        "Enquadrado",
        "Não enquadrado",
        "Em análise de enquadramento",
        "Em ajuste de orçamento",
        "Solicitar adequação técnica",
        "Em adequação técnica",
        "N/A"
    ]

    const pendenciaDoc = [
        "Nenhuma pendência",
        "Pendente CND/CPEN",
        "Pendente Cadin Estadual",
        "Pendente CRF",
        "Pendente CND/CPEN e Cadin Estadual",
        "Pendente CND/CPEN, Cadin Estadual e CRF",
        "Pendente CND/CPEN e CRF",
        "Pendente Cadin Estadual",
        "Pendente Cadin Estadual e CRF",
        "Outras pendencias não listadas (detalhar)"
    ]

    const statusFinanciamento = [
        "1. Abrir pedido de financiamento (PME)",
        "2. Autorização Sefaz (PME)",
        "3. Solicitar à PME o \"kit banco\" (Banco)",
        "4. Enviar o \"kit banco\" - inclui DFs (PME)",
        "5. Validar docs. e analisar SERASA (Banco)",
        "6. Enviar docs. adicionais (PME)",
        "7. Analisar DFs e docs. adicionais (Banco)",
        "8. Cadastro PF e PJ e envio do projeto (PME)",
        "9. Realizar análise de crédito (Banco)",
        "Financiamento contratado",
        "Pedido cancelado - política de crédito",
        "Pedido cancelado - docs. pendentes",
        "Pedido não feito - desistência",
        "Pedido não feito - pendências",
        "N/A"
    ]

    const statusImpl = [
        "a1. Apuração/Visita agendada",
        "a2. Aguardando evidências",
        "a3. Termo de implementação pronto",
        "a4. Dados apurados lançados no SisM&A",
        "b1. Apoio contratado",
        "b2. Plano de M&V elaborado",
        "b3. Acompanhamento em execução",
        "b4. Relatório de M&V elaborado",
        "Não Implementado",
        "Recusado pela empresa"
    ]

    useEffect(() => {
        setForm(editing || {})
        setNewCommentText('')

        if (editing?.id) {
            api.http.get(`/pmes/${editing.id}/comentarios`).then(res => setComments(res.data || []))
        } else {
            setComments([])
        }

        // API: Segmento Industrial
        api.http.get("/setores-atuacao").then(res => setSetores(res.data))

        // API: Usuários consultores habilitados
        api.http.get("/users", {
            params: {
                roleId: ["consultorEE"],
                habilitado: true,
                ordenado_alfa: true,
            }
        }).then(res => setUsuarios(res.data))
    }, [editing])

    const handleSendComment = async () => {
        if (!newCommentText.trim() || !editing?.id) return
        try {
            const res = await api.http.post(`/pmes/${editing.id}/comentarios`, { mensagem: newCommentText })
            setComments([res.data, ...comments])
            setNewCommentText('')
        } catch (err) {
            console.error("Erro ao enviar comentário:", err)
        }
    }

    const handleChange = (field, value) => {
        setForm({ ...form, [field]: value })
    }

    const save = async () => {
        if (form.tableData) delete form.tableData
        if (editing) await api.http.put(`/pmes/${editing.id}`, form)
        else await api.http.post('/pmes', form)
        onClose()
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle>{editing ? 'Editar PME' : 'Nova PME'}</DialogTitle>
            <DialogContent dividers sx={{ display: "flex", gap: 2, height: "70vh", overflow: "hidden", p: 3 }}>

                {/* BLOCO DE DADOS DA PME */}
                <Box sx={{ flex: 3, overflowY: "auto", pr: 2 }}>
                    <Divider>Bloco de Dados Cadastrais da PME</Divider>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <InputMask
                                mask="99.999.999/9999-99"
                                value={form.cnpj || ''}
                                onChange={e => handleChange('cnpj', e.target.value)}
                            >
                                {() => (
                                    <TextField
                                        label="CNPJ da PME"
                                        fullWidth
                                    />
                                )}
                            </InputMask>
                        </Grid>
                        <Grid item xs={6}><TextField label="Nome da empresa (PME)" fullWidth value={form.nomeEmpresa || ''} onChange={e => handleChange('nomeEmpresa', e.target.value)} /></Grid>
                    </Grid>

                    {/* BLOCO DO ATENDIMENTO */}
                    <Divider sx={{ mt: 2 }}>Bloco de Dados do Atendimento</Divider>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={4}><TextField label="Código SENAI" fullWidth value={form.codigoSenai || ''} onChange={e => handleChange('codigoSenai', e.target.value)} /></Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel>Segmento Industrial</InputLabel>
                                <Select
                                    value={form.segmentoIndustrial || ''}
                                    onChange={e => handleChange('segmentoIndustrial', e.target.value)}
                                >
                                    {setores.map(s => (
                                        <MenuItem key={s.id} value={s.nome}>{s.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel>Porte da Empresa</InputLabel>
                                <Select
                                    value={form.porteEmpresa || ''}
                                    onChange={e => handleChange('porteEmpresa', e.target.value)}
                                >
                                    {portesEmpresa.map(p => (
                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}><TextField label="Total de horas previsto" fullWidth value={form.totalHorasPrevisto || ''} onChange={e => handleChange('totalHorasPrevisto', e.target.value)} /></Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel>Unidade do SENAI</InputLabel>
                                <Select
                                    value={form.unidadeSenai || ''}
                                    onChange={e => handleChange('unidadeSenai', e.target.value)}
                                >
                                    {unidadesSenai.map(u => (
                                        <MenuItem key={u} value={u}>{u}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4}>
                            <FormControl fullWidth>
                                <InputLabel>Nome do especialista</InputLabel>
                                <Select
                                    value={form.nomeEspecialista || ''}
                                    onChange={e => handleChange('nomeEspecialista', e.target.value)}
                                >
                                    {usuarios.map(u => (
                                        <MenuItem key={u.id} value={u.nome}>{u.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data início do atendimento"
                                    value={form.dataInicioAtendimento ? new Date(form.dataInicioAtendimento) : null}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataInicioAtendimento', newValue.toISOString())
                                        } else {
                                            handleChange('dataInicioAtendimento', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data regulamentar fim atendimento (120 dias)"
                                    value={
                                        form.dataInicioAtendimento
                                            ? new Date(new Date(form.dataInicioAtendimento).setDate(
                                                new Date(form.dataInicioAtendimento).getDate() + 120
                                            ))
                                            : null
                                    }
                                    readOnly
                                    disabled
                                    format="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    {/* BLOCO APOIO */}
                    <Divider sx={{ mt: 2 }}>Bloco de Apoio Técnico</Divider>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Tipo de apoio de consultores do programa</InputLabel>
                                <Select
                                    value={form.tipoApoioConsultores || ''}
                                    onChange={e => handleChange('tipoApoioConsultores', e.target.value)}
                                >
                                    {tiposApoio.map(t => (
                                        <MenuItem key={t} value={t}>{t}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Consultor técnico envolvido</InputLabel>
                                <Select
                                    value={form.consultorTecnico || ''}
                                    onChange={e => handleChange('consultorTecnico', e.target.value)}
                                >
                                    {usuarios.map(u => (
                                        <MenuItem key={u.id} value={u.nome}>{u.nome}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* BLOCO DE AVANÇO DO DIAGNÓSTICO */}
                    <Divider sx={{ mt: 2 }}>Bloco de Avanço do Diagnóstico</Divider>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>SPRINT do Backlog</InputLabel>
                                <Select
                                    value={form.sprintBacklog || ''}
                                    onChange={e => handleChange('sprintBacklog', e.target.value)}
                                >
                                    {sprints.map(s => (
                                        <MenuItem key={s} value={s}>{s}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}><TextField label="Pessoa contato GIZ" fullWidth value={form.contatoGiz || ''} onChange={e => handleChange('contatoGiz', e.target.value)} /></Grid>
                        <Grid item xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data 1ª Reunião c/PME"
                                    value={form.dataReuniao1 ? new Date(form.dataReuniao1) : null}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataReuniao1', newValue.toISOString())
                                        } else {
                                            handleChange('dataReuniao1', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data 2ª Reunião c/PME"
                                    value={form.dataReuniao2 ? new Date(form.dataReuniao2) : null}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataReuniao2', newValue.toISOString())
                                        } else {
                                            handleChange('dataReuniao2', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data 3ª Reunião c/PME"
                                    value={form.dataReuniao3 ? new Date(form.dataReuniao3) : null}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataReuniao3', newValue.toISOString())
                                        } else {
                                            handleChange('dataReuniao3', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data fim previsto/realizado"
                                    value={form.dataFimPrevisto ? new Date(form.dataFimPrevisto) : null}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataFimPrevisto', newValue.toISOString())
                                        } else {
                                            handleChange('dataFimPrevisto', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6}><TextField label="Saldo de dias execução" fullWidth value={form.saldoDiasExecucao || ''} onChange={e => handleChange('saldoDiasExecucao', e.target.value)} /></Grid>
                        <Grid item xs={6}><TextField label="Situação diagnóstico no BI do SENAI" fullWidth value={form.situacaoDiagnosticoBi || ''} onChange={e => handleChange('situacaoDiagnosticoBi', e.target.value)} /></Grid>
                        <Grid item xs={6}><TextField type="number" label="Valor do Projeto (Investimentos totais projetados)" fullWidth value={form.valorProjeto || ''} onChange={e => handleChange('valorProjeto', e.target.value)} /></Grid>
                    </Grid>

                    {/* BLOCO IMPLEMENTAÇÃO */}
                    <Divider sx={{ mt: 2 }}>Bloco de Dados da Pré-Implementação</Divider>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Status da reunião de implementação</InputLabel>
                                <Select
                                    value={form.statusReuniaoImpl || ''}
                                    onChange={e => handleChange('statusReuniaoImpl', e.target.value)}
                                >
                                    {statusReuniaoImpl.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Modalidade de implementação escolhida</InputLabel>
                                <Select
                                    value={form.modalidadeImpl || ''}
                                    onChange={e => handleChange('modalidadeImpl', e.target.value)}
                                >
                                    {modalidadesImpl.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}><TextField label="Priorização novo contato PME" fullWidth value={form.priorizacaoContato || ''} onChange={e => handleChange('priorizacaoContato', e.target.value)} /></Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Status do apoio para tomada de decisão</InputLabel>
                                <Select
                                    value={form.statusApoioDecisao || ''}
                                    onChange={e => handleChange('statusApoioDecisao', e.target.value)}
                                >
                                    {statusApoioDecisao.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Motivos de não implementação</InputLabel>
                                <Select
                                    value={form.motivosNaoImpl || ''}
                                    onChange={e => handleChange('motivosNaoImpl', e.target.value)}
                                >
                                    {motivosNaoImpl.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Elegibilidade ao FAEE</InputLabel>
                                <Select
                                    value={form.elegibilidadeFaee || ''}
                                    onChange={e => handleChange('elegibilidadeFaee', e.target.value)}
                                >
                                    {elegibilidadeFaee.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Enquadramento à FINEP</InputLabel>
                                <Select
                                    value={form.enquadramentoFinep || ''}
                                    onChange={e => handleChange('enquadramentoFinep', e.target.value)}
                                >
                                    {enquadramentoFinep.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Pendência documental da empresa</InputLabel>
                                <Select
                                    value={form.pendenciaDoc || ''}
                                    onChange={e => handleChange('pendenciaDoc', e.target.value)}
                                >
                                    {pendenciaDoc.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* <Grid item xs={12}><TextField label="Histórico, pendências e próximos passos do processo de decisão e financiamento (inserir: Data, nome e comentário)" fullWidth multiline minRows={3} value={form.historicoPendencias || ''} onChange={e => handleChange('historicoPendencias', e.target.value)} /></Grid> */}
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Status de financiamento</InputLabel>
                                <Select
                                    value={form.statusFinanciamento || ''}
                                    onChange={e => handleChange('statusFinanciamento', e.target.value)}
                                >
                                    {statusFinanciamento.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}><TextField label="Responsável próximo passo" fullWidth value={form.responsavelProximoPasso || ''} onChange={e => handleChange('responsavelProximoPasso', e.target.value)} /></Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data atualização status"
                                    value={form.dataAtualizacaoStatus}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataAtualizacaoStatus', newValue.toISOString())
                                        } else {
                                            handleChange('dataAtualizacaoStatus', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    {/* BLOCO STATUS */}
                    <Divider sx={{ mt: 2 }}>Bloco de Apuração de Resultados e M&V das Implementações</Divider>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Status da implementação</InputLabel>
                                <Select
                                    value={form.statusImpl || ''}
                                    onChange={e => handleChange('statusImpl', e.target.value)}
                                >
                                    {statusImpl.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    label="Data 1º contato"
                                    value={form.dataPrimeiroContato ? new Date(form.dataPrimeiroContato) : null}
                                    onChange={(newValue) => {
                                        if (newValue && isValid(newValue)) {
                                            handleChange('dataPrimeiroContato', newValue.toISOString())
                                        } else {
                                            handleChange('dataPrimeiroContato', null)
                                        }
                                    }}
                                    format="dd/MM/yyyy"
                                    inputFormat="dd/MM/yyyy"
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6}><TextField label="Comentários PMO" fullWidth value={form.comentariosPmo || ''} onChange={e => handleChange('comentariosPmo', e.target.value)} /></Grid>
                        <Grid item xs={6}><TextField label="Volume de MEEs implementadas" fullWidth type="number" value={form.volumeMeesImpl || ''} onChange={e => handleChange('volumeMeesImpl', e.target.value)} /></Grid>
                        <Grid item xs={6}><TextField type="number" label="Valor dos investimentos realizados" fullWidth value={form.valorInvestimentosRealizados || ''} onChange={e => handleChange('valorInvestimentosRealizados', e.target.value)} /></Grid>
                    </Grid>
                </Box>
                <Box sx={{ flex: 1, borderLeft: "1px solid #ddd", pl: 2, display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
                    <Typography variant="subtitle1" gutterBottom>Comentários</Typography>
                    <Box sx={{ flex: 1, overflowY: "auto", pr: 1, mb: 1 }}>
                        {comments.length === 0 ? (
                            <Typography variant="caption" color="text.secondary">
                                {editing?.id ? "Nenhum comentário cadastrado." : "Salve a PME para poder adicionar comentários."}
                            </Typography>
                        ) : (
                            comments.map(c => (
                                <Paper key={c.id} sx={{ p: 1, mb: 1 }}>
                                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>{c.autorNome || c.author || "Usuário"}</Typography>
                                    <Typography variant="body2">{c.mensagem || c.message}</Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {c.createdAt ? new Date(c.createdAt).toLocaleString('pt-BR') : (c.date || '')}
                                    </Typography>
                                </Paper>
                            ))
                        )}
                    </Box>

                    {editing?.id && (
                        <Box sx={{ display: "flex", gap: 1, flexDirection: "column", mt: "auto", pt: 1 }}>
                            <TextField
                                label="Escreva um comentário..."
                                multiline
                                rows={2}
                                fullWidth
                                size="small"
                                value={newCommentText}
                                onChange={e => setNewCommentText(e.target.value)}
                            />
                            <Button
                                variant="contained"
                                size="small"
                                disabled={!newCommentText.trim()}
                                onClick={handleSendComment}
                            >
                                Enviar Comentário
                            </Button>
                        </Box>
                    )}
                </Box>

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={save} variant="contained">Salvar</Button>
            </DialogActions>
        </Dialog>
    )
}
